@use '@lib/assets/styles/main.scss' as *;
.linkContainer {
  display: grid;
  grid-template-columns: min-content auto;
  align-items: center;
  gap: 4px;
  color: $blue500;
  margin-bottom: 16px;
}
